export interface IButtonProps {
  onClick?: () => void;
  children?: React.ReactNode;
  type?: 'primary' | 'default';
  className?: string;
  disabled?: boolean;
}

// TODO 这里只做最简单的实现 后续可以根据需求进行扩展
const Button: React.FC<IButtonProps> = ({ onClick, children, type = 'default', className, disabled = false }) => {
  return (
    <div
      onClick={() => {
        if (disabled) return;
        onClick?.();
      }}
      className={`
        cursor-pointer
        py-0.875 
        px-2.5
        font-size-3
        b-1
        b-solid
        rounded-2.5
        lh-4.2
        ${type === 'default' ? 'b-#DBDEE4 color-#191D26' : 'b-#4981F2 bg-#4981F2 color-#ffffff'}
        
        select-none
        text-center
        ${disabled ? 'opacity-30 cursor-not-allowed' : 'hover:opacity-80% active:opacity-50%'}
        ${className}
      `}
    >
      {children}
    </div>
  );
};

export default Button;
